<template>
  <div class="p-grid">
    <div class="p-col-12" style="width: 100%; padding: 0">
      <ServiceTabs></ServiceTabs>
    </div>
    <div class="p-col-6">
      <ServiceTypeEdit
        @save="$refs.table.fetchList()"
        v-model:visible="editVisible"
        :parent="editParent"
      />
    </div>
    <div class="p-col-12">
      <ServiceTypeTable
        ref="table"
        @create-subtype="showCreateSubtype($event)"
      ></ServiceTypeTable>
    </div>
    <AppFloatButton
      icon="pi pi-plus"
      @click="showCreate()"
      v-if="$ability.can('write', 'Service')"
    />
  </div>
</template>

<script>
import ServiceTypeTable from './components/ServiceTypeTable.vue';
import ServiceTypeEdit from './components/ServiceTypeEdit.vue';
import ServiceTabs from './components/ServiceTabs.vue';

export default {
  name: 'ServiceTypeList',
  data() {
    return {
      editVisible: false,
      editParent: null,
    };
  },
  components: {
    ServiceTypeTable,
    ServiceTypeEdit,
    ServiceTabs,
  },
  methods: {
    showCreate() {
      this.editParent = null;
      this.editVisible = true;
    },
    showCreateSubtype(parent) {
      this.editParent = parent;
      this.editVisible = true;
    },
  },
};
</script>

<style>
</style>
